export const smartInsightsLabelMap = {
    "from_prestigious_college": "Passout from prestigious college",
    "fast_phd": "PhD in under 4 years",
    "is_top_100_india_eng_college": "Top 100 India Engineering Colleges",
    "is_top_100_india_mba_college": "Top 100 India MBA Colleges",
    "is_top_50_uae_colleges": "Top 50 UAE Colleges",
    "is_top_50_uae_engineering": "Top 50 UAE Engineering Colleges",
    "is_top_50_saudi_arabia_colleges": "Top 50 Saudi Arabia Colleges",
    "is_top_50_saudi_arabia_engineering": "Top 50 Saudi Arabia Engineering Colleges",
    "is_top_25_egypt_colleges": "Top 25 Egypt Colleges",
    "is_top_25_egypt_engineering": "Top 25 Egypt Engineering Colleges",
    "is_top_10_qatar_colleges": "Top 10 Qatar Colleges",
    "is_top_10_qatar_mba_colleges": "Top 10 Qatar MBA Colleges",
    "is_top_10_qatar_engineering_colleges": "Top 10 Qatar Engineering Colleges",
    "is_top_10_bahrain_colleges": "Top 10 Bahrain Colleges",
    "is_top_10_bahrain_engineering_colleges": "Top 10 Bahrain Engineering Colleges",
    "is_top_10_bahrain_mba_colleges": "Top 10 Bahrain MBA Colleges",
    "is_top_15_oman_colleges": "Top 15 Oman Colleges",
    "is_top_10_oman_engineering_colleges": "Top 10 Oman Engineering Colleges",
    "is_top_10_oman_mba_colleges": "Top 10 Oman MBA Colleges",
    "is_top_10_kuwait_engineering_colleges": "Top 10 Kuwait Engineering Colleges",
    "is_top_10_kuwait_colleges": "Top 10 Kuwait Colleges",
    "is_top_10_kuwait_mba_colleges": "Top 10 Kuwait MBA Colleges",
    "is_top_100_asia_college": "Top 100 Asia Colleges",
    "is_top_100_asia_eng_college": "Top 100 Asia Engineering Colleges",
    "is_top_100_asia_mba_college": "Top 100 Asia MBA Colleges",
    "startup_exp": "Has startup experience",
    "internally_promoted": "Promoted in current company",
    "founded_a_company": "Has a founder experience",
    "early_employee_of_startup": "Early employee of a startup",
    "has_portfolio": "Has a blog/portfolio"
}

export const showHideLabels = {
    show_only_verified_email :  'Profiles with verified email-id',
    show_only_verified_mobile :  'Profiles with verified mobile no',
    show_resumes_not_viewed :  'Unseen profiles',
    only_confidential_users : 'Confidential profiles',
    exclude_confidential_resume : 'Confidential profiles',
    exclude_sms_sent : 'Already contacted by SMS',
    exclude_email_sent : 'Already contacted by Email',
    exclude_downloaded :  'Already downloaded resumes'
}

export const ALL_NATIONS_OPTIONS = [
    {
        'id':'XX',
        'dId':'XX',
        'code':'XX',
        'dl':'All Nationals',
    }, {
        'id':'ISXXG',
        'dId':'ISXXG',
        'code':'ISXXG',
        'dl':'All Arab Nationals',
    }, {
        'id':'ISGCC',
        'dId':'ISGCC',
        'code':'ISGCC',
        'dl':'All GCC Nationals',
    }, {
        'id':'ISCIS',
        'dId':'ISCIS',
        'code':'ISCIS',
        'dl':'All CIS Nationals',
    }, {
        'id':'ISANG',
        'dId':'ISANG',
        'code':'ISANG',
        'dl':'All Anglophones',
    }, {
        'id':'ISEUR',
        'dId':'ISEUR',
        'code':'ISEUR',
        'dl':'All Europeans',
    }, {
        'id':'ISASI',
        'dId':'ISASI',
        'code':'ISASI',
        'dl':'All Asians',
    }
]

export const ALL_NATIONS_MAPS = {
    'XX':['AF','AL','DZ','AS','AD','AO','AI','AQ','AG','AR','AM','AW','AU','AT','AZ','BS','BH','BD','BB','BY','BE','BZ','BJ','BM','BT','BO','BA','BW','BV','BR','IO','BN','BG','BF','BI','KH','CM','CA','CV','KY','CF','TD','CL','CN','CX','CC','CO','KM','CG','CD','CK','CR','CI','HR','CU','CY','CZ','DK','DJ','DM','DO','EC','EG','SV','GQ','ER','EE','ET','FK','FO','FJ','FI','FR','GF','PF','TF','GA','GM','GE','DE','GH','GI','GR','GL','GD','GP','GU','GT','GN','GW','GY','HT','HM','VA','HN','HK','HU','IS','IN','ID','IR','IQ','IE','IL','IT','JM','JP','JO','KZ','KE','KI','KP','KR','KW','KG','LA','LV','LB','LS','LR','LY','LI','LT','LU','MO','MK','MG','MW','MY','MV','ML','MT','MH','MQ','MR','MU','YT','MX','FM','MD','MC','MN','MS','MA','MZ','MM','NA','NR','NP','NL','AN','NC','NZ','NI','NE','NG','NU','NF','MP','NO','OM','PK','PW','PS','PA','PG','PY','PE','PH','PN','PL','PT','PR','QA','RE','RO','RU','RW','SH','KN','LC','PM','VC','WS','SM','ST','SA','SN','CS','SC','SL','SG','SK','SI','SB','SO','ZA','GS','ES','LK','SD','SR','SJ','SZ','SE','CH','SY','TW','TJ','TZ','TH','TL','TG','TK','TO','TT','TN','TR','TM','TC','TV','UG','UA','AE','GB','US','UM','UY','UZ','VU','VE','VN','VG','VI','WF','EH','YE','ZM','ZW'],
    'ISXXG':['KM','EH','SY','SO','PS','MA','MR','LY','DJ','EG','DZ','ER','IQ','SD','TN','YE','BH','JO','KW','LB','OM','QA','SA','AE'],
    'ISGCC':['BH','KW','OM','QA','SA','AE'],
    'ISCIS':['AM','AZ','BY','KZ','KG','MD','RU','TJ','UZ'],
    'ISANG':['AG','BS','BB','BZ','BW','CM','CA','DM','ER','FM','FJ','GM','GH','GD','GY','IN','IE','JM','KE','KI','LS','LR','MW','MT','MH','MU','NA','NR','NZ','NG','PK','PW','PG','PH','RW','KN','LC','VC','WS','SC','SL','SG','SB','ZA','SD','SZ','TZ','TO','TT','TV','UG','VU','ZM','ZW','AU','IL','GB','US','AS','AI','BM','VG','KY','CX','CC','CK','FK','GI','GU','HK','MS','NU','NF','MP','PN','PR','SH','CO','TK','TC','VI'],
    'ISEUR':['AL','AD','AT','AZ','BY','BE','BA','BG','HR','CY','CZ','DK','EE','FI','GE','DE','GR','HU','IS','IE','IT','KZ','LV','LI','LT','LU','MK','MT','MD','MC','NL','PL','PT','RO','SM','CS','SK','SI','ES','SE','CH','TR','UA','GB','VA','FR','NO','RU'],
    'ISASI':['AF','AM','AZ','BH','BD','BT','IO','BN','KH','CN','CY','CX','CC','TL','GE','HK','IN','ID','IR','IQ','IL','JP','JO','KZ','KW','KG','LA','LB','MO','MY','MV','MN','MM','NP','KP','KR','OM','PK','PS','PH','QA','RU','SA','SG','LK','SY','TW','TJ','TH','TR','TM','AE','UZ','VN','YE']
}

export const channelWiseNationsMap = (cn: number) => {
    if (cn === 4) {
      // For SEA channel (ID 4), only support 'XX' group
      return {
        'XX': ALL_NATIONS_MAPS['XX']
      } as typeof ALL_NATIONS_MAPS;
    }
    return ALL_NATIONS_MAPS;
  }